




















import { Component, Emit, Mixins } from "vue-property-decorator";
import AxiosMixin from "@/mixins/axiosMixin";
import { TokenObj } from "./types";
import { switchStaffWithDeviceGate } from "#/utility/deviceSwitchGate";

interface Staff {
  id: number;
  agreement_id: number;
  office_id: number;
  auth_id: number;
}

@Component
export default class OfficeSelect extends Mixins(AxiosMixin) {
  // 契約内の事業所リスト
  private officeStaffs: Staff[] = [];

  // 選ばれた事業所ID
  private selectId = 0;

  //事業所一覧取得
  mounted() {
    this.postJsonCheck(window.base_url + "/api/getofficestaffs", {}, res => {
      this.officeStaffs = res.data.office_staffs;
    });
  }

  //事業所選択
  clickSelect() {
    const staff = this.officeStaffs.filter(item => item.id == this.selectId);
    if (staff.length == 0) {
      return;
    }
    // 端末制限：切替先契約が制限モードならWebAuthn再ゲートを通す
    switchStaffWithDeviceGate({
      authBackendUrl: window.auth_backend_url,
      axios: window.axios,
      jwt: window.token,
      officeStaffId: staff[0].id,
      onSuccess: (token, refToken) => this.selectoffice(token, refToken),
      onDenied: (msg: string) => {
        this.$openAlert(msg);
      },
      openAlert: this.$openAlert,
      setLoading: (loading: boolean) => {
        this.loading += loading ? 1 : -1;
      }
    });
  }

  @Emit()
  selectoffice(token: string, ref_token: string): TokenObj {
    return { token, ref_token };
  }
}
